import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover, IconButton, Text, TextButton, Layout } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import InfoIcon from '../../assets/icons/Info';
import { Copy } from '../InfoPopover/InfoPopover.styles';
import {
  InfoIconWrapper,
  StatusWrapper,
  StatusTitle,
  StatusDot,
  StyledInfoButton,
} from './VehicleCard.styles';
import { COLORS, SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

interface IStatusProps {
  statusForDot: string;
  vehicleStatus: string;
  popoverDescription: string;
  iconColor?: string;
  oaddStockNumber?: string;
}

const ButtonStyled = styled(IconButton)`
  margin: 0;
`;
const Content = styled.div`
  padding: ${SIZING.unit(2)};
  width: 200px;
  background-color: ${COLORS.grey80};
  position: relative;
  color: white;
  @media ${device.tablet} {
    width: 250px;
  }
  @media ${device.laptop} {
    width: 300px;
  }
  > p {
    color: #f2f2f2;
    font-size: 12px;
  }
`;

const Status: React.FC<IStatusProps> = ({
  statusForDot,
  vehicleStatus,
  popoverDescription,
  iconColor,
  oaddStockNumber,
}) => {
  const { t } = useTranslation();
  const targetRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const ref = useRef<HTMLDivElement | null>(null);
  return (
    <StatusWrapper ref={ref}>
      <Layout align="center" direction="row">
        <StatusDot
          statusForDot={statusForDot}
          data-cy="vehicle-card-status-dot"
          data-testid="vehicle-card-status-dot"
        />
        <StatusTitle data-testid="availability-status" id="status" data-cy="vehicle-card-status">
          {vehicleStatus}
        </StatusTitle>
        <InfoIconWrapper>
          <Popover
            aria-label="Popover title"
            id="popover_title"
            triggerElement={
              <ButtonStyled
                variant="tertiary"
                icon="info-circle"
                size="sm"
                onClick={() => setIsOpen(!isOpen)}
              />
            }
            open={isOpen}
            content={
              <Content>
                <Text>{popoverDescription}</Text>
              </Content>
            }
            onClose={() => setIsOpen(false)}
            withTip
          />
        </InfoIconWrapper>
      </Layout>
      {!!oaddStockNumber?.length && (
        <div>
          {t('vlp.vehicleResults.vehicleCard.stock')} {oaddStockNumber}
        </div>
      )}
    </StatusWrapper>
  );
};

export default Status;
